<template>
  <div>
    <div class="wrapper">
      <div class="title-screen">
        <span>{{ adminText('workflowsAll.new_message_1ed2e7b', 'New message') }}</span>
      </div>
      <text-field v-model="form.title" :label="adminText('workflowsAll.title_768e0c1', 'Title')" autofocus :validator="$v.form.title" />
      <textarea-field
        v-model="form.message"
        :label="adminText('workflowsAll.message_68f4145', 'Message')"
        height="300"
        :validator="$v.form.message"
      />
      <v-checkbox v-model="form.sent" :label="adminText('workflowsAll.send_message_to_subscribers_ab87215', 'Send message to subscribers')" />
      <div class="button-container">
        <main-button :text="adminText('workflowsAll.cancel_77dfd21', 'Cancel')" flat outline @click="$emit('cancel')" />
        <main-button :text="adminText('workflowsAll.save_efc007a', 'Save')" @click="handleCreateOrganizerMessage()" />
      </div>
    </div>
  </div>
</template>

<script>
import WorkflowDisplay from '@/admin-i18n/workflows-all-display'
import { required } from 'vuelidate/lib/validators'
import { submitGuard } from '../../utils'

export default {
  mixins: [WorkflowDisplay],
  name: 'message-to-attendee-container',
  props: {
    eventId: String,
  },
  data() {
    return {
      form: {
        title: null,
        message: null,
        sent: false,
      },
    }
  },
  validations() {
    return {
      form: {
        title: { required },
        message: { required },
      },
    }
  },
  methods: {
    async handleCreateOrganizerMessage() {
      await submitGuard(this, async () => {
        this.$emit('create', this.form)
      })
    },
  },
}
</script>

<style scoped>
@media screen and (max-width: 800px) {
  .title-screen {
    display: none;
  }
  .wrapper {
    margin-top: 1.5rem;
  }
}
.wrapper {
  max-width: 42.5rem;
}
.button-container {
  display: flex;
  justify-content: space-between;
}
.message-style {
  height: 200px;
}
</style>
